import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

const ServerRequest = require('../../actions/request');
import AdminUserLmsDeploymentEditor from '../admin/AdminUserLmsDeploymentEditor';

const propTypes = {
    orgId: PropTypes.number.isRequired,
};

const defaultProps = {};

// Lets org users edit their own org's LTI 1.3 deployments.
// Adding/deleting deployments and changing the OpenID provider are admin-only.
class OrgLmsDeploymentsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deployments: null,
            error: false,
        };
    }

    componentDidMount() {
        this.loadDeployments();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.orgId !== this.props.orgId) {
            this.loadDeployments();
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    loadDeployments=()=>{
        const orgId = this.props.orgId;
        ServerRequest.makeRequest(`/authoring/organization/${orgId}/lms_deployments`, 'GET')
            .then((res) => {
                if (this.unmounted || orgId !== this.props.orgId) return;
                this.setState({ deployments: res || [], error: false });
            })
            .catch((err) => {
                console.log("error", err);
                if (this.unmounted || orgId !== this.props.orgId) return;
                this.setState({ error: true });
            });
    }

    render() {
        if (this.state.error) {
            return (
                <div className="margin-bottom-xl">
                    <h2>LTI 1.3 Deployments</h2>
                    <hr/>
                    <Alert variant="danger">There was a problem loading the LTI 1.3 deployments</Alert>
                </div>
            );
        }
        if (!this.state.deployments || !this.state.deployments.length) {
            return null; // deployments are created by Muzzy Lane admins, so there's nothing to show until one exists
        }

        return (
            <div className="margin-bottom-xl">
                <h2>LTI 1.3 Deployments</h2>
                <hr/>
                {this.state.deployments.map((deployment) => (
                    <AdminUserLmsDeploymentEditor
                        key={deployment.id}
                        user={{ id: this.props.orgId }}
                        deployment={deployment}
                        updateUrl={`/authoring/organization/${this.props.orgId}/update/lms_deployment`}
                        allowDelete={false}
                        onUpdated={this.loadDeployments}
                    />
                ))}
            </div>
        );
    }
}

OrgLmsDeploymentsView.propTypes = propTypes;
OrgLmsDeploymentsView.defaultProps = defaultProps;

export default OrgLmsDeploymentsView;
